import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 726DE98D-9BA1-4E73-8632-FF3F3768A3B3
 * name folder-image
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-image.svg
 * tags
 * - Files / Folders 
 */
export const FolderImageIcon = createSvgIcon(<><path d="M5,17L9.5,11L13,15.5L15.5,12.5L19,17M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6Z" /></>, 'FolderImageIcon');
export default FolderImageIcon